// extracted by mini-css-extract-plugin
export default {"tldTagContainer":"tQXrjG","tldTagSelected":"pg0Nnn","stretch":"uwCFce"};